import NoteIcon from "@assets/icons/note.svg";

import { openNotePage } from "@utils/navigation.util";
import { INoteTagResponse } from "@interfaces/responses.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: INoteTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: INoteTagResponse) => void;
  onRemove?: (tag: INoteTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function NoteTag({ data, isDisabled, onAdd, onRemove, withPlusIcon, iconOnly }: Props) {
  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => openNotePage(data.object.id)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <NoteIcon width={18} height={18} className="flex-shrink-0 dark:text-gray-400" />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.title}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
